// Extracted inline scripts from index.html

  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-8CGPG0N9BP');



        function getWeekNumber(d) {
            // 复制日期避免修改原对象
            const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            // 设置到当年的1月1日
            date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
            const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
            // 计算周数
            const weekNo = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
            return weekNo;
        }
        $(function(){
            let weekNum = getWeekNumber(new Date())
            let leftPicUrl = "	https://energizelab.com/html/phone/images/festival/suspension_left_" +weekNum%9+ ".svg?v=1"
            let rightPicUrl = "	https://energizelab.com/html/phone/images/festival/suspension_right_" +weekNum%9+ ".svg?v=1"
            $("#rope-left").attr("src",leftPicUrl)
            $("#rope-right").attr("src",rightPicUrl)
        })
        function isMobile() {
            // 判断是否为移动设备
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
        $("#ropeBox").click((e)=>{
            let ropeDome = $("#ropeBox")
            if(ropeDome.attr("data-click-flag")==='N')
            {
                ropeDome.css({
                    transform: 'translateY(50px)',
                })
                setTimeout(function(){

                    ropeDome.css({
                        transform: isMobile()?'translateY(-200px)':'translateY(-160px)',
                    })
                    $("#drawBox").css(
                        {
                            transform: 'translateY(0)',
                        }
                    )
                    setTimeout(()=>{
                        $("#goToShopBtn").css({
                            transform: `translateY(0)`,
                            opacity: 1
                        })
                    },800)
                },300)
                ropeDome.attr("data-click-flag","Y")
            }
            e.stopPropagation()
        })
        //跳转到购买
        $("#goToShopBtn").click(()=>{
            location.href = "collections/front-page";
        })
        //隐藏抽屉
        $("#drawBox").mouseleave(()=>{
            hideDraw()
        })
        
        $(document).click((e)=>{
            var $target = $(e.target);
            if (!$target.closest('#drawBox').length) {
                hideDraw()
            }
        })

        function hideDraw(){
            $("#ropeBox").css(
                {
                    transform: 'translateY(0)',
                }
            ).attr('data-click-flag','N')
            $("#drawBox").css(
                {
                    transform: 'translateY(-100vh)',
                }
            )
            $("#goToShopBtn").css(
                {
                    transform: 'translateY(-150px)',
                    opacity: 0
                }
            )
        }
    


     function validateEmailStrict(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(($$[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$$)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    let sendFlag = false    
    $("#get-go").click(()=>{
        if(sendFlag){
            return
        }
        let email = $("#k_id_email").val()
        $("#errorMsg").hide()
        $("#successMsg").hide()
        if(!email ||!validateEmailStrict(email)){
            $("#errorMsg").show()
            $("#errorMsg").html("Invalid email address")
            return
        }
        sendFlag = true
        $(".sendSubBtn").css("background","#7f7f7f")
        let data  = {
            identifiers: [
                {
                    type: "email",
                    channels: {
                        email: {
                            status: "subscribed",
                            statusDate: new Date().toISOString()
                        }
                    },
                    id: email
                }
            ],
            tags:["Store"]
        }
        $.ajax({
            type: 'POST',
            url: "https://api.omnisend.com/v5/contacts",
            headers: {
                Accept: "application/json",
                "X-API-KEY":"64a4ec2963a9504e8a4065e5-wOL6OM52aW0rWL1WC9aDk6lMLY1gBCNluXU0R3QNmP2mXWedFT",
                "Content-Type": "application/json",
            },
            data: JSON.stringify(data),
            timeout: 30000,
            dataType: 'json',
            success: function (datas) {
                $("#errorMsg").hide()
                $("#successMsg").show()
                $("#successMsg").html("Subscription successful, thank you!")
                sendFlag = false
                $(".sendSubBtn").css("background","#3BE3FE")
            },
            error: function (error, textStatus) { 
                $("#errorMsg").show()
                $("#successMsg").hide()
                $("#errorMsg").html("Subscription failed.")
                sendFlag = false
                $(".sendSubBtn").css("background","#3BE3FE")
            }
        });
    })



new WOW().init();
layui.use(["layer", "upload", 'laytpl'], function() {
    var layer = layui.layer,
        admin = layui.admin,
        laytpl = layui.laytpl;

    let click_show_img = $('.click_show_img');
    if (click_show_img.length > 0) {
        click_show_img.each(function(i, ele) {
            layer.photos({
                photos: `.click_show_img_${i}`,
                anim: 5, //0-6的选择，指定弹出图片动画类型，默认随机（请注意，3.0之前的版本用shift参数）
                closeBtn: 1
            });
        })
    }
})
   



    var myhotvideoThumbs = new Swiper(".mySwiper-myhotvideo-thumbs", {

        // cardsEffect: {

        //     slideShadows: false,

        //     //transformEl:'.text',

        // },

        slidesPerView: 'auto',

        slideToClickedSlide: true,

        normalizeSlideIndex: false,

        // centeredSlides: true,



    });



    var myhotvideo = new Swiper(".mySwiper-myhotvideo", {



        grabCursor: true,



        // normalizeSlideIndex: false,

        // slidesPerView: 2,

        // spaceBetween: 10,

        speed: 1000,

        autoplay: {

            delay: 4000,

        },



        // slidesPerColumn: 2,

        // slidesPerColumnFill: 'row',

        slidesPerView: 1.2,

        spaceBetween: 15,

        navigation: {

            prevEl: '.mySwiper-myhotvideo-left',

            nextEl: '.mySwiper-myhotvideo-right',



        },

        centeredSlides: true,

        breakpoints: {

            768: {

                slidesPerView: 1,

                spaceBetween: 0

            },



        },



        thumbs: {

            swiper: myhotvideoThumbs,

        },

    });







    $('.mySwiper_pic').each(function(i, ele) {

        window[`mySwiper_pic_thumbs_${i}`] = new Swiper(`.mySwiper_pic_thumbs_${i}`, {

            // cardsEffect: {

            //     slideShadows: false,

            //     //transformEl:'.text',

            // },

            slidesPerView: 'auto',

            slideToClickedSlide: true,

            normalizeSlideIndex: false,

            // centeredSlides: true,

            observeParents: true,

            observer: true, //开启动态检查器，监测swiper和slide

        });



        let thumbsele = window[`mySwiper_pic_thumbs_${i}`];





        window[`mySwiper_pic_${i}`] = new Swiper(`.mySwiper_pic_${i}`, {

            // pagination: {

            //     el: ".swiper-pagination-more",

            //     type: "progressbar",

            // },

            spaceBetween: 40,

            slidesPerView: 1,

            thumbs: {

                swiper: thumbsele,

            },

            observeParents: true,

            observer: true, //开启动态检查器，监测swiper和slide





        });



        // if (i == $('.mySwiper-engineering').length - 1) {



        // }

    })



    console.log(window, 'sss');

    // if ($('.myswiper-myhotvideo-thumbs').length > 0) {

    //     myhotvideoThumbs.controller.control = myhotvideo; //Swiper1控制Swiper2，需要在Swiper2初始化后

    //     myhotvideo.controller.control = myhotvideoThumbs; //Swiper2控制Swiper1，需要在Swiper1初始化后

    // }

    
